import { useContext } from 'react'

import { IdentityContext } from '../context/IdentityProvider'

import { IdentityContextInterface } from './../types/context/IdentityContextInterface'

const useIdentity: () => IdentityContextInterface = () => {
  const ctx = useContext(IdentityContext)
  if (!ctx) {
    throw new Error('Identity context not initialised')
  }
  return ctx
}

export default useIdentity
